import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SortDescending = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect x="12" y="22" width="8" height="4" rx="2" />
		<rect x="8" y="14" width="16" height="4" rx="2" />
		<rect x="2" y="6" width="28" height="4" rx="2" />
	</svg>
);

export default SortDescending;
